// @flow
import client from '../../client'

// Types
import type { Coordinates } from '../../models/location'

export type RequestSegment = {
  category: string,
  start: Coordinates,
  end: Coordinates,
}
export type ResponseSegment = {
  category: string,
  polyline_points: string,
  line_color: ?string,
  provider_name: ?string,
}

// API Endpoint
export const DIRECTIONS_ENDPOINT = '/locations/directions/'

/**
 * Returns set of coordinates for each step to build direction on SRP map
 * @param  {Array} segments An array with steps to get directions for.
 * @return {Promise|Error} A Promise eventually resolving to the suggestions.
 */
export const getDirections = (
  segments: Array<RequestSegment>
): Promise<ResponseSegment[]> => {
  const query = { segments }
  return client
    .post(DIRECTIONS_ENDPOINT, { body: query })
    .then((response) => response.segments)
}

export default getDirections
